import { render } from "./ClientAbonements.vue?vue&type=template&id=3ae78029"
import script from "./ClientAbonements.vue?vue&type=script&lang=js"
export * from "./ClientAbonements.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__